export default __webpack_public_path__ + "static/media/certificate.6357a17a.png";